import createstore from "../../../../../../store";
import { ValidationErrorMessage as ErMsg } from "./ValidationErrorMessage";

let Policy = [];

const isfurtureappallowedCheck = () => {
  if (Policy.isfurtureappallowed && Policy.notifyinadvanceday <= 0) {
    return ErMsg.Ernotifyinadvanceday;
  }
  if (Policy.isfurtureappallowed && Policy.minleavecountforapp < 0) {
    return ErMsg.Erminleavecountforapp;
  }
  if (Policy.isfurtureappallowed && Policy.notifynotbeforeday <= 0) {
    return ErMsg.Ernotifynotbeforeday;
  }
  if (
    Policy.isfurtureappallowed &&
    Policy.notifynotbeforeday < Policy.notifyinadvanceday
  ) {
    return ErMsg.Ernotifynotbeforedaygreater;
  }
};
const totalExperienceCheck = () => {
  if (Policy.experienceinmonth == 0) {
    return 0;
  } else if (Policy.experienceinmonth == null) {
    return ErMsg.ErExperience;
  }
};
// const onlyCarryForwardCheck = () => {
//   if (Policy.iscarryforwardpolicy) {
//     if (!Policy.forwardtypeid) {
//       return ErMsg.Erforwardtypeid;
//     }
//     if (Policy.forwardtypeid == 2) {
//       if (Policy.carryforwardunused == 0) {
//         return ErMsg.Ercarryforwardunused;
//       }
//     } else if (Policy.forwardtypeid == 3) {
//       if (Policy.carryforwardunusedperc == 0) {
//         return ErMsg.Ercarryforwardunusedperc;
//       }
//     }
//   }
// };

const holidayCarryfowrod = () => {
  if (Policy.iscarryforwardallowed) {
    if (!Policy.forwardtypeid) {
      return ErMsg.Erforwardtypeid;
    }
    if (Policy.forwardtypeid == 2) {
      if (
        Policy.carryforwardunused == 0 ||
        // Policy.carryforwardunused == "" ||
        Policy.carryforwardunused == null
      ) {
        return ErMsg.Ercarryforwardunused;
      }
    } else if (Policy.forwardtypeid == 3) {
      if (
        Policy.carryforwardunusedperc == 0 ||
        Policy.carryforwardunusedperc == "" ||
        Policy.carryforwardunusedperc == null
      ) {
        return ErMsg.Ercarryforwardunusedperc;
      }
    }
  }
};

const remaningtypeidCheck = (obj) => {
  if (Policy.carryforward[obj].remaningtypeid == 1) {
    return 0;
  }
  if (
    Policy.carryforward[obj].remaningtypeid == 2 &&
    Policy.carryforward[obj].noofremaning == 0
  ) {
    return ErMsg.Ernoofremaning;
  }
  if (
    Policy.carryforward[obj].remaningtypeid == 2 &&
    !Policy.carryforward[obj].noofremaning
  ) {
    return ErMsg.Ernoofremaning;
  }
  if (
    Policy.carryforward[obj].remaningtypeid == 3 &&
    Policy.carryforward[obj].remaningperc == 0
  ) {
    return ErMsg.Erremaningperc;
  }
  if (
    Policy.carryforward[obj].remaningtypeid == 3 &&
    !Policy.carryforward[obj].remaningperc
  ) {
    return ErMsg.Erremaningperc;
  }
};

const pendingactiontypeidCheck = (obj) => {
  if (!Policy.carryforward[obj].pendingactiontypeid) {
    return ErMsg.Erpendingactiontypeid;
  }
  if (Policy.carryforward[obj].pendingactiontypeid == 1) {
    return 0;
  }
  if (Policy.carryforward[obj].pendingactiontypeid == 2) {
    if (remaningtypeidCheck(obj)) {
      return remaningtypeidCheck(obj);
    }
  } else if (Policy.carryforward[obj].pendingactiontypeid == 3) {
    if (remaningtypeidCheck(obj)) {
      return remaningtypeidCheck(obj);
    }
  }
};

const EncashmentCheck = () => {
  if (
    Policy.iscarryforwardallowed &&
    Policy.carryforward.iscarryforwardpolicy
  ) {
    if (!Policy.carryforward.carryforwardpolicy.forwardtypeid) {
      return ErMsg.Erforwardtypeid;
    }
    if (Policy.carryforward.carryforwardpolicy.forwardtypeid == 2) {
      if (
        Policy.carryforward.carryforwardpolicy.carryforwardunused == 0 ||
        !Policy.carryforward.carryforwardpolicy.carryforwardunused
      ) {
        return ErMsg.Ercarryforwardunused;
      }
      if (pendingactiontypeidCheck("carryforwardpolicy")) {
        return pendingactiontypeidCheck("carryforwardpolicy");
      }
    } else if (Policy.carryforward.carryforwardpolicy.forwardtypeid == 3) {
      if (
        Policy.carryforward.carryforwardpolicy.carryforwardunusedperc == 0 ||
        !Policy.carryforward.carryforwardpolicy.carryforwardunusedperc
      ) {
        return ErMsg.Ercarryforwardunusedperc;
      }
      if (pendingactiontypeidCheck("carryforwardpolicy")) {
        return pendingactiontypeidCheck("carryforwardpolicy");
      }
    }
  } else if (
    Policy.iscarryforwardallowed &&
    !Policy.carryforward.iscarryforwardpolicy
  ) {
    if (!Policy.carryforward.encashmentpolicy.encashmenttypeid) {
      return ErMsg.Erencashmenttypeid;
    }
    if (Policy.carryforward.encashmentpolicy.encashmenttypeid == 2) {
      if (
        Policy.carryforward.encashmentpolicy.encashmentunused == 0 ||
        !Policy.carryforward.encashmentpolicy.encashmentunused
      ) {
        return ErMsg.Erencashmentunused;
      }
      if (pendingactiontypeidCheck("encashmentpolicy")) {
        return pendingactiontypeidCheck("encashmentpolicy");
      }
    } else if (Policy.carryforward.encashmentpolicy.encashmenttypeid == 3) {
      if (
        Policy.carryforward.encashmentpolicy.encashmentunusedperc == 0 ||
        !Policy.carryforward.encashmentpolicy.encashmentunusedperc
      ) {
        return ErMsg.Erencashmentunusedperc;
      }
      if (pendingactiontypeidCheck("encashmentpolicy")) {
        return pendingactiontypeidCheck("encashmentpolicy");
      }
    }
  }
};

const giftCheck = () => {
  if (
    (Policy.isgiftallowed && !Policy.giftactiontypeid) ||
    (Policy.isgiftallowed &&
      Policy.giftactiontypeid == 1 &&
      Policy.giftperc == 0) ||
    (Policy.isgiftallowed &&
      Policy.giftactiontypeid == 2 &&
      Policy.noofgift == 0)
  ) {
    return ErMsg.ErGiftLeave;
  }
};
const SandwichLeaves = () => {
  if (Policy.isintervinigallowed) {
    const policy = Policy.interviningpolicy;
    if (
      (!policy.holiday && !policy.optholiday && !policy.weeklyoff) ||
      (policy.holiday &&
        !(
          policy.isinterviningholiday ||
          policy.isprefixholiday ||
          policy.issuffixholiday
        )) ||
      (policy.optholiday &&
        !(
          policy.isinterviningoptholiday ||
          policy.isprefixoptholiday ||
          policy.issuffixoptholiday
        )) ||
      (policy.weeklyoff &&
        !(
          policy.isinterviningweeklyoff ||
          policy.isprefixweeklyoff ||
          policy.issuffixweeklyoff
        ))
    ) {
      return ErMsg.ErDeductLeaves;
    }
  }
};
const LeaveUsage = () => {
  if (Policy.maxleaveinprobation == null) {
    return ErMsg.ErLeaveDuringProbation;
  }
  if (Policy.maxleave == null) {
    return ErMsg.ErMaxLeaves;
  }
  if (Policy.maxconsecutiveleave == null) {
    return ErMsg.ErMaxConseLeaves;
  }
  if (Policy.maxleavedurationtypeid == null) {
    return ErMsg.ErLeaveDuration;
  }
};
const OnlyLeaveUsage = () => {
  if (Policy.maxleave == null) {
    return ErMsg.ErMaxLeaves;
  }
  if (Policy.maxconsecutiveleave == null) {
    return ErMsg.ErMaxConseLeaves;
  }
  if (Policy.maxleavedurationtypeid == null) {
    return ErMsg.ErLeaveDuration;
  }
};
const isoverutilizationallowedCheck = () => {
  if (!Policy.isoverutilizationallowed) {
    return 0;
  }
  if (Policy.isoverutilizationallowed) {
    if (!Policy.overutilizationpolicy.excessleaveactiontypeid) {
      return ErMsg.Erexcessleaveactiontypeid;
    }
    if (Policy.overutilizationpolicy.excessleaveactiontypeid == 1) {
      // return ErMsg.Erexcesspaidlimit
      return "";
    }
    if (Policy.overutilizationpolicy.excessleaveactiontypeid == 2) {
      return 0;
    }
    if (
      Policy.overutilizationpolicy.excessleaveactiontypeid == 3 &&
      !Policy.overutilizationpolicy.altleaveid
    ) {
      return ErMsg.ErAltLeaveType;
    }
    if (
      Policy.overutilizationpolicy.excessleaveactiontypeid == 3 &&
      !Policy.overutilizationpolicy.altexcessleaveactiontypeid
    ) {
      return ErMsg.ErCountLeave;
    }
  }
};
const isleaveallowedinnoticeCheck = () =>
  Policy.isleaveallowedinnotice &&
  Policy.handleLeaveCount &&
  Policy.leavecountinnotice == 0
    ? ErMsg.Erleavecountinnotice
    : 0;
const ispastappallowedCheck = () => {
  if (Policy.ispastappallowed) {
    return Policy.apppastday <= 0 ? ErMsg.Erapppastday : 0;
  }
};
const isattachmentCheck = () => {
  if (Policy.isattachment && Policy.attachmentduration == null) {
    return ErMsg.Erisattachment;
  }
  if (Policy.isattachment && Policy.attachmentnote == "") {
    return ErMsg.ErisattachmentInst;
  }
};
const LeaveBalanceAvailable = () => {
  if (Policy.isaccrual == null) {
    return ErMsg.ErLeaveBalanceAvailable;
  }
  if (
    Policy.isaccrual &&
    Policy.isprobationaccurallimit &&
    Policy.accuralfrequencytype == null
  ) {
    return "Please select accural frequency type";
  }
  if (
    !Policy.isaccrual &&
    Policy.isprobationaccurallimit &&
    Policy.probationaccurallimit == null
  ) {
    return ErMsg.ErProbationLeaves;
  }
  if (
    Policy.isaccrual &&
    Policy.isprobationaccurallimit &&
    Policy.unusedprobationleavetypeid == null
  ) {
    return ErMsg.ErAccruedBtUncredited;
  }
};
// const OnlyProRateCheck = () => {
//   if (!Policy.proratetypeid) {
//     return ErMsg.ErProRateType;
//   }
//   if (Policy.proratetypeid && !Policy.creditmodetypeid) {
//     return ErMsg.Ercreditmodetypeid;
//   }
//   if (Policy.proratetypeid == (1 || 2) && Policy.creditmodetypeid == 2 && Policy.midjoinstartday == 0) {
//     return ErMsg.Ermidjoinstartday;
//   }
// };
const ProRateCheck = () => {
  if (Policy.isprorate == null) {
    return ErMsg.ErProRate;
  }
  if (Policy.isprorate && !Policy.proratetypeid) {
    return ErMsg.ErProRateType;
  }
  if (Policy.isprorate && Policy.proratetypeid && !Policy.creditmodetypeid) {
    return ErMsg.Ercreditmodetypeid;
  }
  if (
    Policy.isprorate &&
    Policy.proratetypeid == (1 || 2) &&
    Policy.creditmodetypeid == 2 &&
    Policy.midjoinstartday == 0
  ) {
    return ErMsg.Ermidjoinstartday;
  }
  if (
    !Policy.isprorate &&
    !Policy.proratetypeid &&
    Policy.proratetypeid !== 0
  ) {
    return ErMsg.ErProRateType;
  }
  if (!Policy.isprorate && Policy.proratetypeid == 2) {
    if (!Policy.creditdaymonth) {
      return ErMsg.Ercreditdaymonth;
    } else if (Policy.creditdaymonth) {
      const date = Policy.creditdaymonth.format("DD");
      if (date == "Invalid date") {
        return ErMsg.Ercreditdaymonth;
      }
    }
    if (!Policy.othercreditmodetypeid) {
      return ErMsg.Erothercreditmodetypeid;
    }
  }
};
const genderidsCheck = () =>
  !Policy.genderids || Policy.genderids.length < 0 ? ErMsg.Ergenderids : 0;
const employeetypeidsCheck = () => {
  console.log("Policy.employeetypeids: ", Policy.employeetypeids);
  return !Policy.employeetypeids || Policy.employeetypeids.length < 0
    ? ErMsg.Eremployeetypeids
    : 0;
};
const maritalstatusidsCheck = () =>
  !Policy.maritalstatusids || Policy.maritalstatusids.length < 0
    ? // ? ErMsg.Ermaritalstatusids
      ""
    : 0;
const clubbingleaveidCheck = () => {
  if (Policy.isclubbingallowed) {
    if (Policy.clubbingleaveid == null) {
      return ErMsg.Erclubbingleaveid;
    }
  }
};
const isallocatebalanceCheck = () =>
  Policy.annualbalance == 0 ? ErMsg.Erannualbalance : 0;

// eslint-disable-next-line import/prefer-default-export
export const Validation = (leavetypeid, ParentIndex, islast = false) => {
  console.log("ParentIndex: ", ParentIndex);
  let errorMessage = "";
  let isError = false;
  if (!leavetypeid) {
    errorMessage = ErMsg.ErLeaveType;
    isError = true;
  }
  if (!ParentIndex && ParentIndex < 0) {
    // console.log("issue1");
    errorMessage = ErMsg.ErPolicyDetails;
    isError = true;
  }
  const { InitLeavesPolicy } = createstore.getState();
  if (
    InitLeavesPolicy.policy.length == 0 ||
    !InitLeavesPolicy.policy[ParentIndex]
  ) {
    // console.log("issue2");
    errorMessage = ErMsg.ErPolicyDetails;
    isError = true;
  }
  if (
    !isError &&
    islast &&
    InitLeavesPolicy.policy.length != InitLeavesPolicy.details.length
  ) {
    errorMessage = ErMsg.ErPolicyDetails;
    isError = true;
  }
  if (!isError) {
    Policy = InitLeavesPolicy.policy[ParentIndex];
    if (!Policy.leavename || Policy.leavename.trim() == "") {
      isError = true;
      errorMessage = ErMsg.ErName;
    }
    if (!isError) {
      switch (leavetypeid) {
        case 1: {
          if (Policy.earnedleave == 0) {
            isError = true;
            errorMessage = ErMsg.ErEarnedLeaves;
          } else if (Policy.completionday == 0) {
            isError = true;
            errorMessage = ErMsg.ErCompletionDays;
          } else if (
            Policy.credittypeid == 1 &&
            !(
              Policy.ispresentday ||
              Policy.isleave ||
              Policy.isabsentday ||
              Policy.isweekoff ||
              Policy.isholiday
            )
          ) {
            isError = true;
            errorMessage = ErMsg.ErSpecificDay;
          } else if (employeetypeidsCheck()) {
            isError = true;
            errorMessage = employeetypeidsCheck();
          } else if (isattachmentCheck()) {
            isError = true;
            errorMessage = isattachmentCheck();
          } else if (LeaveUsage()) {
            isError = true;
            errorMessage = LeaveUsage();
          } else if (isfurtureappallowedCheck()) {
            isError = true;
            errorMessage = isfurtureappallowedCheck();
          } else if (ispastappallowedCheck()) {
            isError = true;
            errorMessage = ispastappallowedCheck();
          } else if (isleaveallowedinnoticeCheck()) {
            isError = true;
            errorMessage = isleaveallowedinnoticeCheck();
          } else if (SandwichLeaves()) {
            isError = true;
            errorMessage = SandwichLeaves();
          } else if (clubbingleaveidCheck()) {
            isError = true;
            errorMessage = clubbingleaveidCheck();
          } else if (EncashmentCheck()) {
            isError = true;
            errorMessage = EncashmentCheck();
          } else if (isoverutilizationallowedCheck()) {
            isError = true;
            errorMessage = isoverutilizationallowedCheck();
          } else if (giftCheck()) {
            isError = true;
            errorMessage = giftCheck();
          }
          break;
        }
        case 3: {
          if (!Policy.maxmonthhour || Policy.maxmonthhour == 0) {
            isError = true;
            errorMessage = ErMsg.Ermaxmonthhour;
          } else if (!Policy.maxonedayhour || Policy.maxonedayhour == 0) {
            isError = true;
            errorMessage = ErMsg.Ermaxonedayhour;
          } else if (employeetypeidsCheck()) {
            isError = true;
            errorMessage = employeetypeidsCheck();
          } else if (ProRateCheck()) {
            isError = true;
            errorMessage = ProRateCheck();
          } else if (!Policy.minhour || Policy.minhour == 0) {
            isError = true;
            errorMessage = ErMsg.Erminhour;
          } else if (holidayCarryfowrod()) {
            isError = true;
            errorMessage = holidayCarryfowrod();
          } else if (ispastappallowedCheck()) {
            isError = true;
            errorMessage = ispastappallowedCheck();
          } else if (!Policy.approvaltypeid) {
            isError = true;
            errorMessage = ErMsg.Erapprovaltypeid;
          }
          break;
        }
        case 4: {
          if (OnlyLeaveUsage()) {
            isError = true;
            errorMessage = OnlyLeaveUsage();
          } else if (isfurtureappallowedCheck()) {
            isError = true;
            errorMessage = isfurtureappallowedCheck();
          } else if (ispastappallowedCheck()) {
            isError = true;
            errorMessage = ispastappallowedCheck();
          } else if (SandwichLeaves()) {
            isError = true;
            errorMessage = SandwichLeaves();
          } else if (clubbingleaveidCheck()) {
            isError = true;
            errorMessage = clubbingleaveidCheck();
          }
          break;
        }
        case 2:
        case 5: {
          if (Policy.isallocatebalance && isallocatebalanceCheck()) {
            isError = true;
            errorMessage = isallocatebalanceCheck();
          } else if (genderidsCheck()) {
            isError = true;
            errorMessage = genderidsCheck();
          } else if (employeetypeidsCheck()) {
            isError = true;
            errorMessage = employeetypeidsCheck();
          } else if (maritalstatusidsCheck()) {
            isError = true;
            errorMessage = maritalstatusidsCheck();
          } else if (ProRateCheck()) {
            isError = true;
            errorMessage = ProRateCheck();
          } else if (LeaveBalanceAvailable()) {
            isError = true;
            errorMessage = LeaveBalanceAvailable();
          } else if (isattachmentCheck()) {
            isError = true;
            errorMessage = isattachmentCheck();
          } else if (LeaveUsage()) {
            isError = true;
            errorMessage = LeaveUsage();
          } else if (isfurtureappallowedCheck()) {
            isError = true;
            errorMessage = isfurtureappallowedCheck();
          } else if (ispastappallowedCheck()) {
            isError = true;
            errorMessage = ispastappallowedCheck();
          } else if (isleaveallowedinnoticeCheck()) {
            isError = true;
            errorMessage = isleaveallowedinnoticeCheck();
          } else if (isoverutilizationallowedCheck()) {
            isError = true;
            errorMessage = isoverutilizationallowedCheck();
          } else if (SandwichLeaves()) {
            isError = true;
            errorMessage = SandwichLeaves();
          } else if (EncashmentCheck()) {
            isError = true;
            errorMessage = EncashmentCheck();
          } else if (clubbingleaveidCheck()) {
            isError = true;
            errorMessage = clubbingleaveidCheck();
          } else if (giftCheck()) {
            isError = true;
            errorMessage = giftCheck();
          }
          break;
        }
        case 6:
        case 7: {
          if (Policy.isallocatebalance && isallocatebalanceCheck()) {
            isError = true;
            errorMessage = isallocatebalanceCheck();
          } else if (genderidsCheck()) {
            isError = true;
            errorMessage = genderidsCheck();
          } else if (employeetypeidsCheck()) {
            isError = true;
            errorMessage = employeetypeidsCheck();
          } else if (maritalstatusidsCheck()) {
            isError = true;
            errorMessage = maritalstatusidsCheck();
          } else if (Policy.experienceinmonth == null) {
            isError = true;
            errorMessage = ErMsg.Erexperienceinmonth;
          } else if (ProRateCheck()) {
            isError = true;
            errorMessage = ProRateCheck();
          } else if (
            Policy.isaccrual &&
            Policy.isprobationaccurallimit &&
            Policy.probationaccurallimit == 0
          ) {
            isError = true;
            errorMessage = ErMsg.Erprobationaccurallimit;
          } else if (isattachmentCheck()) {
            isError = true;
            errorMessage = isattachmentCheck();
          } else if (isfurtureappallowedCheck()) {
            isError = true;
            errorMessage = isfurtureappallowedCheck();
          } else if (ispastappallowedCheck()) {
            isError = true;
            errorMessage = ispastappallowedCheck();
          } else if (isleaveallowedinnoticeCheck()) {
            isError = true;
            errorMessage = isleaveallowedinnoticeCheck();
          } else if (isoverutilizationallowedCheck()) {
            isError = true;
            errorMessage = isoverutilizationallowedCheck();
          } else if (clubbingleaveidCheck()) {
            isError = true;
            errorMessage = clubbingleaveidCheck();
          }
          break;
        }
        case 11: {
          if (!Policy.isallocatebalance && isallocatebalanceCheck()) {
            isError = true;
            errorMessage = isallocatebalanceCheck();
          } else if (employeetypeidsCheck()) {
            isError = true;
            errorMessage = employeetypeidsCheck();
          } else if (totalExperienceCheck()) {
            isError = true;
            errorMessage = totalExperienceCheck();
          } else if (ProRateCheck()) {
            isError = true;
            errorMessage = ProRateCheck();
          } else if (
            Policy.isaccrual &&
            Policy.isprobationaccurallimit &&
            Policy.probationaccurallimit == 0
          ) {
            isError = true;
            errorMessage = ErMsg.Erprobationaccurallimit;
          } else if (isattachmentCheck()) {
            isError = true;
            errorMessage = isattachmentCheck();
          } else if (LeaveUsage()) {
            isError = true;
            errorMessage = LeaveUsage();
          } else if (isfurtureappallowedCheck()) {
            isError = true;
            errorMessage = isfurtureappallowedCheck();
          } else if (ispastappallowedCheck()) {
            isError = true;
            errorMessage = ispastappallowedCheck();
          } else if (isleaveallowedinnoticeCheck()) {
            isError = true;
            errorMessage = isleaveallowedinnoticeCheck();
          } else if (SandwichLeaves()) {
            isError = true;
            errorMessage = SandwichLeaves();
          } else if (clubbingleaveidCheck()) {
            isError = true;
            errorMessage = clubbingleaveidCheck();
          } else if (isoverutilizationallowedCheck()) {
            isError = true;
            errorMessage = isoverutilizationallowedCheck();
          } else if (EncashmentCheck()) {
            isError = true;
            errorMessage = EncashmentCheck();
          } else if (giftCheck()) {
            isError = true;
            errorMessage = giftCheck();
          }
          break;
        }
        case 8:
        case 9:
        case 10: {
          if (Policy.isbalance && Policy.annualbalance == 0) {
            isError = true;
            errorMessage = ErMsg.Erannualbalance;
          } else if (employeetypeidsCheck()) {
            isError = true;
            errorMessage = employeetypeidsCheck();
          } else if (maritalstatusidsCheck()) {
            isError = true;
            errorMessage = maritalstatusidsCheck();
          } else if (!Policy.creditmodetypeid || Policy.creditmodetypeid == 0) {
            isError = true;
            errorMessage = ErMsg.Ercreditmodetypeid;
          } else if (Policy.creditmodetypeid == 1 && Policy.daysbefore <= 0) {
            isError = true;
            errorMessage = ErMsg.Erdaysbefore;
          } else if (isfurtureappallowedCheck()) {
            isError = true;
            errorMessage = isfurtureappallowedCheck();
          } else if (ispastappallowedCheck()) {
            isError = true;
            errorMessage = ispastappallowedCheck();
          } else if (clubbingleaveidCheck()) {
            isError = true;
            errorMessage = clubbingleaveidCheck();
          }
          break;
        }
        case 12: {
          if (Policy.isallocatebalance && isallocatebalanceCheck()) {
            isError = true;
            errorMessage = isallocatebalanceCheck();
          } else if (employeetypeidsCheck()) {
            isError = true;
            errorMessage = employeetypeidsCheck();
          } else if (totalExperienceCheck()) {
            isError = true;
            errorMessage = totalExperienceCheck();
          } else if (ProRateCheck()) {
            isError = true;
            errorMessage = ProRateCheck();
          } else if (
            !Policy.isaccrual &&
            Policy.isprobationaccurallimit &&
            Policy.creditlimitinnonaccural == 0
          ) {
            isError = true;
            errorMessage = ErMsg.Erprobationcreditlimit;
          } else if (isattachmentCheck()) {
            isError = true;
            errorMessage = isattachmentCheck();
          } else if (Policy.maxleave == 0) {
            isError = true;
            errorMessage = ErMsg.ErMaxLeaves;
          } else if (isfurtureappallowedCheck()) {
            isError = true;
            errorMessage = isfurtureappallowedCheck();
          } else if (isoverutilizationallowedCheck()) {
            isError = true;
            errorMessage = isoverutilizationallowedCheck();
          }
          break;
        }
        default:
          break;
      }
    }
  }
  return [isError, errorMessage];
};
